// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"51f2bc41","483":"60cc5045","693":"8dec81eb"}[chunkId] + ".chunk.js";
};